// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f-1q","content":"styles_content__6SPSx"};